/**
 * Formats a number with grouped thousands and custom decimal points.
 *
 * @param value The number to format
 * @param decimals The number of decimal places
 * @param decPoint The string to use for the decimal point
 * @param thousandsSep The string to use for the thousands separator
 * @param roundingMode The rounding mode to use (floor, ceil, or round)
 * @returns The formatted number as a string
 */
export function formatNumber(
    value: number,
    decPoint: string = ".",
    thousandsSep: string = ",",
    roundingMode: "floor" | "ceil" | "round" = "round"
  ): string {
    let decimals = 0;
    // Ensure the value is a number
    let num = Number(value);
    if (isNaN(num)) {
      return "NaN";
    }
  
    // Apply rounding
    switch (roundingMode) {
      case "floor":
        num = Math.floor(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
        break;
      case "ceil":
        num = Math.ceil(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
        break;
      case "round":
      default:
        num = Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
        break;
    }
  
    // Split the number into integer and decimal parts
    let [intPart, fracPart = ""] = num.toFixed(decimals).split(".");
  
    // Add thousands separators to the integer part
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
  
    // Combine integer and fractional parts
    return fracPart ? `${intPart}${decPoint}${fracPart}` : intPart;
  }